import clsx from 'clsx'
import React, {useState} from 'react'
import {BiChevronRight} from 'react-icons/bi'
import {useLocation} from 'react-router'
import {handleLabelNameChanges} from 'src/cms/helpers/automation'
import {checkIsActive, KTSVG} from '../../../helpers'
import {useLayout} from '../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  children?: React.ReactNode
}

const AsideMenuItemWithSub: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  //added line to fix issue
  const [isOpen, setIsOpen] = useState(false)

  const {aside} = config
  //added
  const toggleMenu = (e: React.MouseEvent) => {
    e.preventDefault() // Prevents unwanted navigation

    setTimeout(() => {
      setIsOpen((prev) => !prev)
    }, 0) // ✅ Delays state update slightly to prevent glitches
  }

  return (
    <div
      className={clsx('menu-item', {'here show': isActive}, 'menu-accordion')}
      data-kt-menu-trigger='click'
      data-cy={`${handleLabelNameChanges(title)}-menu`}
    >
      {/* <span className='menu-link' data-cy={`${handleLabelNameChanges(title)}-menu-link`}> */}
      <span
        className='menu-link d-flex justify-between align-items-center'
        onClick={toggleMenu} // ✅ Add click handler
        data-cy={`${handleLabelNameChanges(title)}-menu-link`}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className='menu-title'>{title}</span>
        <span className='menu-arrow'>
          <BiChevronRight />
        </span>
      </span>
      {/* old one with issue of not opening */}
      {/* <div className={clsx('menu-sub menu-sub-accordion', {'menu-active-bg': isActive})}> */}
      <div
        className={clsx('menu-sub menu-sub-accordion', {'d-block': isOpen, 'd-none': !isOpen})}
        style={{display: isOpen ? 'block' : 'none'}} // ✅ Ensure it shows/hides properly
      >
        {children}
      </div>
    </div>
  )
}

export {AsideMenuItemWithSub}
